export default "__VITE_ASSET__f46a713b__"